module.exports = __webpack_public_path__ + "static/media/pipa-logo.cbc49b45.svg";